"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
class DocumentBrowserShell extends React.Component {
  render() {
    if (this.props.hideDocViewer) {
      let content = this.props.popoutReplacementChild;
      if (!content) {
        content = /* @__PURE__ */ jsx("div", { className: "document-indexer__hidden-state", children: "Document Viewer Hidden." });
      }
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: "document-browser",
          style: { overflow: "auto" },
          "data-component": "DocumentBrowserShell",
          children: [
            /* @__PURE__ */ jsx("div", { style: { float: "right", padding: "5px" }, children: /* @__PURE__ */ jsx(
              "a",
              {
                onClick: () => this.props.closeDocumentViewerPopout(),
                className: "icon-document-collapse"
              }
            ) }),
            content
          ]
        }
      );
    } else {
      return (
        // chrome 53 on windows needs the maxWidth, or this box
        // doesn't flex correctly
        /* @__PURE__ */ jsxs(
          "div",
          {
            "data-component": "DocumentBrowserShell",
            className: "document-browser document-indexer__document-browser-wrapper",
            style: { maxWidth: "100%" },
            children: [
              /* @__PURE__ */ jsxs("div", { className: "document-browser__header", children: [
                /* @__PURE__ */ jsx("div", { className: "document-browser__header-component-selection", children: /* @__PURE__ */ jsx("div", { className: "component-selector", children: this.componentSelections() }) }),
                /* @__PURE__ */ jsx("div", { className: "document-browser__header-current", children: this.props.mainImageTitle }),
                /* @__PURE__ */ jsx("div", { className: "document-browser__header-documents" }),
                this.closeLink(),
                this.expandLink(),
                this.popoutLink()
              ] }),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: "row document-browser__container" + (this.props.annotating ? " document-browser__annotating" : ""),
                  children: this.props.children
                }
              )
            ]
          }
        )
      );
    }
  }
  componentSelections() {
    if (!this.props.selectableComponents) {
      return null;
    }
    return this.props.selectableComponents.map((component) => {
      const active = this.props.selectedComponent && component.label == this.props.selectedComponent.label;
      const css = classNames({ active });
      return /* @__PURE__ */ jsx(
        "a",
        {
          onClick: () => this.componentSelected(component),
          className: css,
          children: component.label
        },
        `component-selector-${component.label}`
      );
    });
  }
  componentSelected(component) {
    if (this.props.componentSelected) {
      this.props.componentSelected(component);
    }
  }
  closeLink() {
    if (this.props.closeLink) {
      return /* @__PURE__ */ jsx("div", { className: "document-browser__header-close-link", children: this.props.closeLink });
    }
  }
  expandLink() {
    if (this.props.expandLink) {
      return /* @__PURE__ */ jsx("div", { className: "document-browser__header-expand-link", children: this.props.expandLink });
    }
  }
  popoutLink() {
    if (this.props.popoutLink) {
      return /* @__PURE__ */ jsx("div", { className: "document-browser__header-popout-link", children: this.props.popoutLink });
    }
  }
}
const connectedDocumentBrowserShell = connect(
  (state) => ({
    annotating: state.annotationMode.annotating
  })
)(DocumentBrowserShell);
export default connectedDocumentBrowserShell;
